var LostPass = function() {
    return {
        init: function() {
            $('#submit_changepass_btn').click(function() {
                $('#changepass_response').text('');
                if ($('#password').val() != $('#password2').val()) {
                    $('#changepass_response').text('Οι κωδικοί δεν είναι ίδιοι!');
                    return;
                }
                if ($('#password').val() ==  '' || $('#password').val().length <= 3) {
                    $('#changepass_response').text('Ο κωδικός είναι πολύ μικρός!');
                    return;
                }
                $('#changepass_form').attr('action', '/change-pass' + window.location.search);
                $('#changepass_form').submit();
            });
            
            $('#submit_forgotpass_btn').click(function() {
                $('#forgotpass_response').text('');
                if ($('#username_forgot').val() == '' && $('#email_forgot').val() == '') {
                    $('#forgotpass_response').text('Συμπληρώστε το e-mail σας ή το username σας!');
                    return;
                }
                Ajax.forgotPass(
                    $('#username_forgot').val(),
                    $('#email_forgot').val(),
                    function(res) {
                        $('#forgotpass_response').text(
                            'Αν το email ή username που έδωσες αντιστοιχεί σε χρήστη, θα λάβεις email με οδηγίες σύντομα.');
                    });
            });
        }
    };
}();
